import confetti from 'canvas-confetti';
import { thumbUrl } from './api';

const COLORS = ['#E50914', '#FFD60A', '#FFFFFF', '#22C55E', '#3B82F6', '#F97316', '#EC4899'];
let pointer = { x: 0, y: 0, at: 0 };
let lastFire = 0;
window.addEventListener('pointerdown', (e) => { pointer = { x: e.clientX, y: e.clientY, at: Date.now() }; }, { capture: true, passive: true });

const reduced = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

const origin = () => {
  if (Date.now() - pointer.at < 2000) return pointer;
  const r = document.activeElement?.getBoundingClientRect?.();
  return r && r.width ? { x: r.left + r.width / 2, y: r.top + r.height / 2 } : { x: window.innerWidth / 2, y: window.innerHeight / 2 };
};

const cartTarget = () => {
  const el = [...document.querySelectorAll('[data-testid="nav-shopping-list"]')].find((n) => n.getClientRects().length);
  if (!el) return null;
  const r = el.getBoundingClientRect();
  const x = r.left + r.width / 2, y = r.top + r.height / 2;
  const hit = y > 0 && y < window.innerHeight && document.elementFromPoint(x, y);
  return hit && el.contains(hit) ? { el, x, y } : null;
};

const bump = (el) => { el.classList.remove('cart-bump'); void el.offsetWidth; el.classList.add('cart-bump'); setTimeout(() => el.classList.remove('cart-bump'), 600); };

const fly = (from, to, image) => {
  const node = document.createElement('div');
  node.className = 'fly-to-cart';
  if (image) node.style.backgroundImage = `url("${thumbUrl(image)}")`;
  node.style.left = `${from.x - 22}px`;
  node.style.top = `${from.y - 22}px`;
  document.body.appendChild(node);
  const dx = to.x - from.x, dy = to.y - from.y;
  const anim = node.animate([
    { transform: 'translate(0,0) scale(1)', opacity: 1 },
    { transform: `translate(${dx * 0.45}px, ${Math.min(dy * 0.45, 0) - 90}px) scale(.85)`, opacity: 1, offset: 0.45 },
    { transform: `translate(${dx}px, ${dy}px) scale(.2)`, opacity: 0.7 },
  ], { duration: 720, easing: 'cubic-bezier(.45,.05,.55,.95)' });
  anim.onfinish = () => { node.remove(); bump(to.el); };
};

export const celebrateAdd = (image) => {
  const now = Date.now();
  if (now - lastFire < 400) return;
  lastFire = now;
  const from = origin(), to = cartTarget();
  if (reduced()) { if (to) bump(to.el); return; }
  confetti({ particleCount: 90, spread: 75, startVelocity: 38, gravity: 1.1, ticks: 160, scalar: 0.9, colors: COLORS, zIndex: 9999,
    origin: { x: from.x / window.innerWidth, y: from.y / window.innerHeight } });
  if (to) fly(from, to, image);
};
